// extracted by mini-css-extract-plugin
export default {"hint":"LocationSelect-module__hint--2301"};